import React from 'react';
import { IslandButton, TrevorIcon } from '@trevor/ui-components';
import { NavigationButtonProps } from './types';

export const Table: React.FC<NavigationButtonProps> = (props) => (
  <IslandButton
    content={<TrevorIcon name="table" />}
    tooltipContent="Dashboard table"
    {...props}
  />
);
